import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=0507750a&scoped=true&"
import script from "./ContactDialog.vue?vue&type=script&lang=js&"
export * from "./ContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=0507750a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507750a",
  null
  
)

export default component.exports